import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';
import type {
  GetInvitationByTokenResponse,
  AcceptInvitationResponse,
  DeclineInvitationResponse,
} from '@/types/api/responses';

export const invitationsService = {
  getByToken: (token: string) =>
    apiClient.get<GetInvitationByTokenResponse>(
      API_ENDPOINTS.INVITATIONS.BY_TOKEN(token)
    ),

  accept: (token: string) =>
    apiClient.post<AcceptInvitationResponse>(
      API_ENDPOINTS.INVITATIONS.ACCEPT(token)
    ),

  decline: (token: string) =>
    apiClient.post<DeclineInvitationResponse>(
      API_ENDPOINTS.INVITATIONS.DECLINE(token)
    ),
};
